import React, { useMemo, useEffect } from 'react';
import { List, Item, Description, NotResults } from './styled';

interface Props {
  dataList: any;
  handleClickItem?: Function;
  handleRefItems?: Function;
  showFirstItems?: number;
  handleKeyDown?: Function;
  message?: boolean;
  location?: boolean;
}

export const SearchResults: React.FC<Props> = ({
  dataList,
  handleClickItem,
  handleRefItems,
  showFirstItems,
  handleKeyDown,
  message,
  location
}) => {

  const refSuggestionsList = useMemo(
    () => Array.from({ length: dataList.length }).map(() => React.createRef()),
    [dataList.length]
  );

  useEffect(() => {
    handleRefItems && handleRefItems(refSuggestionsList);
  });

  const createElement = (element) => {
    const tag =  `<p><span>${element.name}</span></p>`;
    return tag;
  };

  const createElementLocation= (district, province, department) => {
    const tag = `<p><span>${district}</span>${getText(province)}${getText(department)}</p>`;
    return tag;
  };

  const getText = (ubigeo: string) => ubigeo ? `, ${ubigeo}` : '';

  const setUrbanizationOrDistrict = (element) => {
    if (element) {
      const initial = element.id.charAt(0);
      if (initial === 'D') {
        return element.district_name;
      }
      return element.urbanization_name;
    }
  };

  const setDistrictOrProvince = (element) => {
    if (element && element) {
      const initial = element.id.charAt(0);
      if (initial === 'D') {
        return element.prdataovince_name;
      }
      return element.district_name;
    }
  };

  return (
    <List showFirstItems={showFirstItems} onKeyDown={handleKeyDown}>
      {
        dataList && dataList.length > 0 && dataList.map((element, index) => (
          <Item
            key={index}
            ref={refSuggestionsList[index]}
            data-index={index}
            tabIndex="-1"
            onMouseDown={() => handleClickItem && handleClickItem(index)}
          >
            {
              location ?
                <Description
                dangerouslySetInnerHTML={
                  {
                    __html: createElementLocation(
                      setUrbanizationOrDistrict(element),
                      setDistrictOrProvince(element),
                      element.department_name
                    )
                  }
                } /> 
              :
              <Description
                dangerouslySetInnerHTML={
                  {
                    __html: createElement(
                      element
                    )
                  }
                } />
            }
          </Item>
        ))
      }
      { message && <NotResults dangerouslySetInnerHTML={{
        __html: 'No se encontraron resultados.'
      }} />}
    </List>
)};

SearchResults.defaultProps = {
  showFirstItems: 2
}
